export default {
  init() {},
  finalize() {},
};
